import {
  ActionIcon,
  Card,
  CopyButton,
  Stack,
  TextInput,
  Tooltip,
  Text,
  Alert,
} from "@mantine/core"
import {
  IconCopy,
  IconAlertCircle,
  IconExternalLink,
} from "@tabler/icons-react"

import { useUser } from "@costory/front/components/auth/UserContext"
import { runtimeConfig } from "@costory/front/lib/runtimeConfig"

function maskToken(input: string): string {
  const visiblePart = input.slice(0, 6)
  const maskedLength = input.length - 6
  const maskedPart = "*".repeat(maskedLength)
  return visiblePart + maskedPart
}

export function ApiTokens() {
  const { currentOrg } = useUser()

  if (!currentOrg.externalApiToken) {
    return (
      <Alert icon={<IconAlertCircle size={16} />} color="yellow">
        No API token found for your organization. Please contact support.
      </Alert>
    )
  }

  return (
    <Stack>
      <Card withBorder>
        <Stack>
          <Text size="sm" c="dimmed">
            API token for your organization.
          </Text>
          <Text size="sm" c="dimmed">
            See the{" "}
            <a
              href={`${runtimeConfig.VITE_API_URL || ""}/docs`}
              target="_blank"
              rel="noreferrer"
              style={{ display: "inline-flex", alignItems: "center", gap: 4 }}
            >
              API documentation <IconExternalLink size="0.9rem" />
            </a>{" "}
            for more information.
          </Text>
          <Stack>
            <TextInput
              value={maskToken(currentOrg.externalApiToken)}
              readOnly
              label="API Token"
              description="Use this token in the X-API-Token header for API requests"
              rightSectionPointerEvents="all"
              rightSectionWidth={42}
              rightSection={
                <CopyButton value={currentOrg.externalApiToken}>
                  {({ copied, copy }) => (
                    <Tooltip label={copied ? "Copied" : "Copy"}>
                      <ActionIcon
                        color={copied ? "teal" : "gray"}
                        onClick={copy}
                        variant={copied ? "filled" : "default"}
                        aria-label="Copy API Token"
                        radius="sm"
                        size="sm"
                      >
                        <IconCopy size={16} />
                      </ActionIcon>
                    </Tooltip>
                  )}
                </CopyButton>
              }
            />
          </Stack>
        </Stack>
      </Card>
    </Stack>
  )
}
